import { Box, Button, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import UploadImagesContent from './popoverUploadImages/UploadImagesContent';

const PopoverUploadImages = ({ viewId }) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const box = React.useRef(null);

	React.useEffect(() => {
		// Function for click event

		function handleOutsideClick(event) {
			if (isOpen && box.current && !box.current.contains(event.target)) {
				setIsOpen(false);
			}
		}

		// Adding click event listener
		document.addEventListener('click', handleOutsideClick);
		return () => document.removeEventListener('click', handleOutsideClick);
	}, [box]);

	return (
		<Box ref={box} position={'relative'}>
			<Button
				onClick={() => setIsOpen(!isOpen)}
				m={0}
				borderColor="gray.200"
				lineHeight={6}
				h={'auto'}
				fontSize={'xs'}
				variant="outline"
			>
				Images
			</Button>
			<UploadImagesContent {...{ isOpen, viewId }} />
		</Box>
	);
};

export default PopoverUploadImages;
